import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
import api from '../lib/api';
import DropCountdown from '../components/DropCountdown';

const DropsPage = () => {
  const [drops, setDrops] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/drops');
        if (!cancelled && res.data?.success) setDrops(res.data.data || []);
      } catch {/* swallow */}
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  const joinNotify = async (id) => {
    await api.post(`/drops/${id}/notify`);
  };

  return (
    <div className="min-h-[80vh] bg-neutral-100 p-6 md:p-12">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <Flame size={32} className="text-orange-500" />
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter">DROPS</h1>
        </div>

        {loading ? (
          <div className="bg-white border-4 border-black h-80 animate-pulse" />
        ) : drops.length === 0 ? (
          <div className="bg-yellow-300 border-4 border-black p-16 text-center shadow-[16px_16px_0px_black]">
            <h2 className="text-4xl md:text-6xl font-black mb-4">NO DROPS SCHEDULED</h2>
            <p className="font-mono">Subscribe to be notified when new drops go live.</p>
          </div>
        ) : (
          <div className="space-y-8">
            {drops.map((drop) => (
              <DropCountdown
                key={drop._id}
                drop={drop}
                onJoinNotify={() => joinNotify(drop._id)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DropsPage;
